import React, {Component} from 'react';

// Tools
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import propTypes from 'prop-types';

// Components
import {Button} from '@mui/material';
import Icon from '@mui/material/Icon';
import Loading from '../core/loading';
import Error from '../core/error';

// Styles
import './async-media-items-report-result-modal.scss';

const ASYNC_REPORT_FORM_NAME = 'mediaItemAsyncReport';

class AsyncMediaItemsReportResultModal extends Component {
    renderMassActionLink = (data) => (
        <Link
            // response from Twister includes a forward slash
            to={['/investigation/mass-action-results', data].join('')}
        >
            Link to report
        </Link>
    );

    renderResponseMessage = (data, error) => {
        const {onReset} = this.props;
        return (
            <div className="async-media-items-report-modal--overlay--success">
                {data && !error && (
                    <div className="async-media-items-report-modal--overlay--success--text">
                        <h5>Your request has been accepted</h5>
                        <p>Your request is being processed. To track this operation, use the following link.</p>
                        <p> {this.renderMassActionLink(data)}</p>
                    </div>
                )}
                {error && <Error error={error} onReset={onReset} />}
            </div>
        );
    };

    render() {
        const {onReset, isOpen, servicesSearchData} = this.props;
        const {fetching, error, searchData} = servicesSearchData;

        return (
            isOpen && (
                <div className="async-media-items-report-modal">
                    <div className="async-media-items-report-modal--overlay-wrapper">
                        <div className="async-media-items-report-modal--overlay">
                            <div className="async-media-items-report-modal--overlay--header">
                                <div className="async-media-items-report-modal--title">
                                    <strong>Media Items Mass Actions Response</strong>
                                </div>
                                <Button className="async-media-items-report-modal--close" type="link" onClick={onReset}>
                                    <Icon fontType="fa" iconName="close" />
                                </Button>
                            </div>

                            {fetching ? (
                                <div className="async-media-items-report-modal--loading">
                                    <div className="async-media-items-report-modal--loading--text">
                                        Loading Results...
                                    </div>
                                    <Loading loading={fetching} />
                                </div>
                            ) : (
                                this.renderResponseMessage(searchData, error)
                            )}
                        </div>
                    </div>
                </div>
            )
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const {servicesSearchData} = state;
    const formName = ownProps.isDuplicateReport ? 'mediaItemDuplicateTitlesAsyncReport' : ASYNC_REPORT_FORM_NAME;

    return {
        servicesSearchData: servicesSearchData[formName] || {},
    };
};

AsyncMediaItemsReportResultModal.propTypes = {
    isOpen: propTypes.bool,
    onReset: propTypes.func,
    servicesSearchData: propTypes.object,
};

export default connect(mapStateToProps)(AsyncMediaItemsReportResultModal);
